import { loadMessagesByIds } from 'APP/Tasks/messaging/loadMessagesByIds/loadMessagesByIds';
import { Group } from 'STORE/Groups/Group';

export function loadPinMessages(group: Group): void {
  const messageIdsToLoad = group.pinnedMessages.data.filter(
    (messageId) => !group.messagesStore.getMessageById(messageId)
  );

  if (messageIdsToLoad.length) {
    loadMessagesByIds(group.id, messageIdsToLoad);
  }
}
